

import {useEffect} from 'react';
import {connect} from 'react-redux';
import DocumentMeta from 'react-document-meta';
import {withRouter} from 'react-router-dom';
import StartupIndia from './components/StartupIndia/StartupIndia';
import MentorShipProgram from './components/MentorShipProgram/MentorShipProgram';
import NationalMentorShip from './components/NationalMentorShip/NationalMentorShip';
import MentorShipPlatformMobile from './components/MentorShipPlatformMobile/MentorShipPlatformMobile';


import {getAboutUsData} from './dependencies/action';
import { initGA, logPageView } from '../../analytics'


const AboutUs=(props) => {
    
    useEffect(() => {
        // to call the initialise google analytics funtion
        try {
          initGA();
          window.GA_INITIALIZED = true;
          // to save the number og visitors on this side
          logPageView();
        } catch (error) {}
      }, [window]);

    const {getAboutUsData,currentInterventionList}=props
    useEffect(() => {
        getAboutUsData(localStorage.getItem("SelectedLang"));
    },[getAboutUsData])
    
    const Banner=currentInterventionList?.Banner;
    const KeyFunctionsofStartupIndiaNationalMentorshipPlatform=currentInterventionList?.KeyFunctionsofStartupIndiaNationalMentorshipPlatform;
    const ObjectivesofStartupIndiaNationalMentorshipPlatform=currentInterventionList?.ObjectivesofStartupIndiaNationalMentorshipPlatform;
    const meta={
        title: 'MAARG',
        description: '',
        canonical: 'https://maarg.startupindia.gov.in/',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
            }
        }
    };
    return (
        <DocumentMeta {...meta}>
            {currentInterventionList?
                (
                    <>
                    
                        <StartupIndia data={Banner} />
                        <MentorShipProgram data={Banner} />
                        <MentorShipPlatformMobile data={KeyFunctionsofStartupIndiaNationalMentorshipPlatform} />
                        <NationalMentorShip data={ObjectivesofStartupIndiaNationalMentorshipPlatform} />
                    </>
                )
                :null
            }


        </DocumentMeta>
    );
}

const mapStateToProps=(state) => {
    return {
        currentInterventionList: state.AboutUsReducer.currentInerventionList.list,
    }
}
export default connect(mapStateToProps,{getAboutUsData})(withRouter(AboutUs))